const COOKIE_NAME = "gu-cmp-disabled";
const disable = () => {
    document.cookie = `${COOKIE_NAME}=true`;
};
const enable = () => {
    document.cookie = `${COOKIE_NAME}=false`;
};
const isDisabled = () => new RegExp(`${COOKIE_NAME}=true(\\W+|$)`).test(document.cookie);
export { disable, enable, isDisabled };
